import { type FunctionComponent, useState } from 'react'
import { useIntl } from 'react-intl'
import {
  MenuBase,
  MenuItem,
  Divider,
  NavigationBar,
} from '@retailer-platform/shared-components/src/tds'
import { useHelpMenuLinks } from '../nav-v2/components/HelpMenu/hooks/useHelpMenuLinks'
import { UserFeedbackSurveyController } from '../../common/retailer-satisfaction-survey/user-feedback/UserFeedbackSurveyController'
import { useUserFeedbackContext } from '../user-feedback/UserFeedbackContext'
import { useTopBarMenu } from './TopBarMenuContext'

export const TdsHelpMenu: FunctionComponent = () => {
  const intl = useIntl()
  const { isOpen, setIsOpen } = useTopBarMenu('help')
  const [showFeedback, setShowFeedback] = useState(false)
  const { hideFeedbackButton, showFeedbackButton } = useUserFeedbackContext()
  const menuLinks = useHelpMenuLinks()

  const handleFeedbackClick = () => {
    setIsOpen(false)
    setShowFeedback(true)
    hideFeedbackButton()
  }

  const handleFeedbackClose = () => {
    setShowFeedback(false)
    showFeedbackButton()
  }

  const trigger = (
    <NavigationBar.Button
      aria-label={intl.formatMessage({ id: 'app.nav.helpMenu.label' })}
      icon="help"
      onPress={() => setIsOpen(!isOpen)}
    />
  )

  return (
    <>
      <MenuBase target={trigger} isOpen={isOpen} onMenuStateChange={setIsOpen} position="bottomEnd">
        {menuLinks.map(({ href, messageId, openInNewTab }) => (
          <MenuItem
            key={messageId}
            text={intl.formatMessage({ id: messageId })}
            href={href}
            target={openInNewTab ? '_blank' : undefined}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
          />
        ))}
        <Divider />
        <MenuItem
          text={intl.formatMessage({ id: 'give_feedback' })}
          onClick={handleFeedbackClick}
        />
      </MenuBase>
      {showFeedback && <UserFeedbackSurveyController onClose={handleFeedbackClose} />}
    </>
  )
}
